/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import getPayoutState from './initial-state';
import type { GetPayoutSettingsViewModelApiResponse } from 'tradera/state/services/types/webapi-member-generated';

const payoutSlice = createSlice({
    name: 'payout',
    initialState: getPayoutState(),
    reducers: {
        receivePayoutsSettings: (
            state,
            { payload }: PayloadAction<GetPayoutSettingsViewModelApiResponse>,
        ) => {
            state.payoutSettings = payload;
            state.isFetching = false;
        },
        removePayoutDestination: (state) => {
            state.payoutSettings = {
                ...state.payoutSettings,
                payoutDestination: undefined,
            };
        },
        setFetching: (state, { payload }) => {
            state.isFetching = payload;
        },
    },
});

export const { receivePayoutsSettings, removePayoutDestination, setFetching } =
    payoutSlice.actions;

export default payoutSlice.reducer;
